import { render, staticRenderFns } from "./ztIcon.vue?vue&type=template&id=77c16e94&scoped=true"
import script from "./ztIcon.vue?vue&type=script&lang=js"
export * from "./ztIcon.vue?vue&type=script&lang=js"
import style0 from "../../../../styles/components/ztIcon.css?vue&type=style&index=0&id=77c16e94&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../../../../../web-empleado/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77c16e94",
  null
  
)

export default component.exports